<template>
  <div>
    <mt-header fixed title="工序更新" class="head">
      <router-link to="/main" slot="left">
        <mt-button style="font-size:.3rem" icon='back'></mt-button>
      </router-link>
    </mt-header>
    <div>
      <div class="loadmore-container">
        <mt-loadmore :top-method="loadTop" ref="loadmore">
          <div class="item c_flex c_m_t_10 c_p_10 bg_white block">
            <div class="c_flex_1">
              <div class="title  guest" @click="toCustomerDetail">
                <div style="padding-left:5vw"></div>
                <div class="guestInfo">
                  <img v-if="user.avatar" :src="qiniu+user.avatar">
                  <img v-else src="../assets/images/constructionphoto.jpg"><br>
                  <span class='name'>{{user.contactname || user.name}}</span><br>
                  <span class='c_gray_drak'>
                    <a :href="'tel:'+user.phone" class="c_blue userPhone">{{user.contactphone || user.phone}}</a>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!--客户信息结束, 勘察时间开始-->
          <div class="item c_flex c_m_t_10 c_p_10 bg_white block" v-if="usertype=='sysuser' && isEditSurveydate">
            <div class="c_flex_1 ">
              <div class="title c_nowrap guest">
                <p>勘查时间：<span class='c_gray_drak' v-if='user.surveydate'>{{user.surveydate | getDatetime}}</span></p>
                <span class='c_blue' @click='change()' v-if='user.surveydate'>修改</span>
                <span class='c_blue_navy' @click='change()' v-else>填写勘查时间</span>
              </div>
            </div>
          </div>
          <!--  修改状态  -->
          <div class="item c_flex c_m_t_10 c_p_10 bg_white block" v-if="usertype=='sysuser'">
            <div class="c_flex_1">
              <div class="title c_nowrap guest">
                <p>工程状态：<span class='c_gray_drak'>{{user.servicestate | filter_servicestate}}</span></p>
                <span class='c_blue' @click='edit_servicestate()' v-if='user.servicestate<2'>修改</span>
              </div>
            </div>
          </div>


          <!--多个工序流程-->
          <div class="select scroll-hidden c_m_t_10" :class="isfix?'fix':''">
            <mt-navbar v-model="selected">
              <!--<mt-tab-item id="1" data-type="勘察" @click.native="filterClick">勘察</mt-tab-item>-->
              <!--<mt-tab-item id="2" data-type="勘察部位" @click.native="filterClick">勘察部位</mt-tab-item>-->

              <mt-tab-item v-for="(item,index) in procedureTypeList" :key="index" :id="index+1"
                           :data-orderid="item.orderid" :data-type="item.type" :data-index="index"
                           @click.native="filterClick">
                {{item.type | filter_procedureType}}
              </mt-tab-item>

            </mt-navbar>
          </div>

          <!--工序流程-->
          <div v-for="(n,index) in list" :key='index' class="item c_flex c_m_t_10 c_p_10 bg_white" @click="edit(index)">
            <div class="num c_flex c_flex_center c_p_10" :class="n.state>1?'bg_blue':'bg_gray'">{{index+1}}</div>
            <div class="c_flex_1 c_nowrap">
              <div class="c_p_t_10 c_p_l_10 title c_nowrap">{{n.itemname}}
                <span class="c_gray c_size_10" v-if='n.operator'>「{{n.operator | usertype}}」</span></div>
              <div class="c_p_10">
                <div>{{ n.ts | getDatetime }}</div>
                <!--<div class="c_blue"></div>-->
              </div>
            </div>
            <div class="state c_p_10 c_flex c_item_center">
              <!--<span class="tips" :class="{'bg_green_light' : n.state==2 , 'bg_yellow_light':n.state==1}">-->
              <span class="tips" :class="n.state==1?'bg_yellow_light':n.state==2?'bg_green_light':'bg_gray'">
                {{n.state==0?'未开始':(n.state==1?'进行中':(n.state==2?'已完成':(n.state==3?'验收不通过':(n.state==-1?'已作废':'订单关闭'))))}}</span>
            </div>
            <!-- 右面箭头图标 -->
            <div class="c_p_10 c_flex c_flex_center">
              <i class="iconfont icon-jiantou"></i>
            </div>
          </div>

        </mt-loadmore>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        qiniu: this.$$api.mobile.qiniuDownload,
        selected: "1",
        billid: '',
        list: [],
        user: {
          avatar: '',
        },
        usertype: '',
        // 是否吸顶
        isfix: false,
        // 工序名称列表
        procedureTypeList: [],
        // 当前展示的工序流程
        procedureType: 0,
        // 是否可以修改勘察时间
        isEditSurveydate: false,
      }
    },
    mounted: function () {
      this.$indicator.close();
      var obj = JSON.parse(localStorage['obj']);
      if (obj && obj.billid) {
        this.billid = obj.billid;
        // this.load();
        this.procedureType = obj.procedureType || 0;
        this.getList();
      }
      // 滚动事件 -- 吸顶
      window.addEventListener('scroll', this.handleScroll);

    },
    methods: {
      change() {
        var surveydate = this.user.surveydate || '';
        this.$router.push({name: "search",
          params: {
            'type': 'ajax',
            'isOpera': true,
            'api': 'editSurveydate',
            'tips': '请选择时间',
            'title': '选择时间',
            'val': surveydate,
            'isInput': true,
            'inputType': 'date'
          }
        });
      },
      edit_servicestate() {
        var servicestate = this.user.servicestate || "0";
        this.$router.push({name: "search",
          params: {
            'type': 'ajax',
            'isOpera': true,
            'api': 'editServicestate',
            'tips': '请选择状态',
            'title': '修改状态',
            'val': servicestate,
            'isInput': true,
            "inputType": "servicestate"
          }
        });
      },
      edit(index) {
        //if拦截当前步骤未完成不能点击下一步
        // this.$store.construction = this.list[index];
        var procedure = this.list[index];
        var procedure_prev = this.list[(index - 1 < 0 ? 0 : index - 1)];
        var relyLast = procedure.relyLast;
        var state = procedure_prev.state;
        if ((relyLast == 'Y') && (state < 2) && index!=0) {
          this.$toast("请完成上序流程");
          return;
        }
        var obj = JSON.parse(localStorage['obj']);
        var procedure_new = {};
        procedure_new.billid = procedure.billid;
        procedure_new.itemname = procedure.itemname;
        procedure_new.type = procedure.type;
        procedure_new.billbid = procedure.billbid;
        procedure_new.itemid = procedure.itemid;
        procedure_new.formcode = procedure.formcode;
        procedure_new.formid = procedure.formid;
        obj.procedure = procedure_new;
        localStorage['obj'] = JSON.stringify(obj);
        if (this.list[index].formcode == "takeorder" && obj.servicestate == 2) {
          this.$toast("该工程已完工，不能下单");
          return;
        }
        this.$router.push({name: this.list[index].formcode});
      },

      load: function (orderid, type) {
        if (!type) return;
        var $that = this;
        this.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getProcedureList, {
          billid: this.billid,
          orderid: orderid,
          type: type,
        }, function (res) {
          if (res.status == 200) {
              var msg = res.data.detailMsg.data;
            $that.list = msg;
            $that.user = JSON.parse(localStorage['obj']);
            $that.usertype = JSON.parse(localStorage['userinfo']).usertype;
          } else {
            $that.$toast(res.data.msg);
          }
          $that.$indicator.close();
          window.scrollTo(0, 190);
        });
      },

      // navbar 吸顶事件
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 160) {
          this.isfix = true;
        } else if(scrollTop<100){
          this.isfix = false;
        }

        //滑动到指定位置
        var mainContainer = document.querySelectorAll('.select .mint-navbar')[0],
          scrollToContainer = document.querySelectorAll('.select .mint-tab-item.is-selected')[0];
        if (mainContainer && scrollToContainer) mainContainer.scrollLeft = scrollToContainer.offsetLeft;

      },

      // 请求 多个工序名称列表
      getList(fun) {
        var $that = this;
        this.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getProcedureTypeList, {
          billid: this.billid
        }, function (res) {
          if (res.status == 200) {
            var msg = res.data.detailMsg.data;
            $that.procedureTypeList = msg;
            if (msg.length > 0) {
              let procedureType = $that.procedureType || 0;
              let orderid = msg[procedureType].orderid || '';
              let type = msg[procedureType].type;
              $that.$indicator.close();
              $that.load(orderid, type);
              $that.selected = Number(procedureType) + 1;
              $that.getState();
            }else{
              $that.$messagebox.confirm("该工程暂未下单",'提示',{
                showCancelButton:false
              }).then((action)=>{
                $that.$router.go(-1);
              });
            }
          } else {
            $that.$toast(res.data.msg);
          }
          $that.$indicator.close();
          if (fun) fun();
        });
      },
      //获取工程当前状态
      getState() {
        let $that = this;
        this.$ajax.get(this.$$api.mobile.getProcedureState, {
          billid: this.billid
        }, function (res) {
          if (res.status == 200) {
            var msg = res.data.detailMsg.data;
            if (msg == 0) {
              $that.isEditSurveydate = true;
            }
          }
        });
      },

      // 选择工序查看
      filterClick(e) {
        let orderid = e.currentTarget.dataset.orderid || '';
        let type = e.currentTarget.dataset.type;
        let index = e.currentTarget.dataset.index;
        this.procedureType = index;
        var obj = JSON.parse(localStorage['obj']);
        obj.procedureType = index;
        localStorage['obj'] = JSON.stringify(obj);
        //ajax  -- 请求工序接口
        this.load(orderid, type);
      },

      // 下拉事件
      loadTop: function () {
        var $that = this;
        $that.getList(function () {
          setTimeout(function () {
            $that.$refs.loadmore.onTopLoaded();
          }, 500);
        });
      },

      toCustomerDetail:function () {
        var obj = JSON.parse(localStorage['userinfo'])||'';
        if(obj && obj.usertype=='sysuser'){
          this.$router.push('/customerDetail');
        }
      }

    },
  }
</script>
<style scoped>
  .title {
    font-size: 4vw;
    font-weight: bold;
  }

  .state {
    margin-right: 3vw;
  }

  .num {
    color: #fff;
    border-radius: 50%;
    position: relative;
    width: 3vw;
    height: 3vw;
    margin: auto;
    z-index: 10;
    font-size: 3vw;
  }

  .num:after {
    content: '';
    display: block;
    position: absolute;
    top: 7vw;
    left: 3.5vw;
    z-index: 5;
    width: 0;
    height: 16vw;
    border-left: 1px solid rgb(184, 195, 206);
  }

  .item:last-child .num:after {
    border: 0;
  }

  .tips {
    font-size: 4vw;
    background: #ccc;
    border-radius: 16px;
    color: #fff;
    width: 20vw;
    height: 10vw;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .guest {
    font-weight: normal !important;
    display: flex;
    justify-content: space-between;
    padding-left: 5vw;
    padding-right: 10vw;
  }

  .guest p {
    margin: 0;
    padding: 0;
  }

  .name {
    display: inline-block;
    width: 20vw;
    padding-bottom: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }

  .guestInfo {
    width: 100%;
    text-align: center;
  }

  .guestInfo > img {
    width: 20vw;
    height: 20vw;
    border-radius: 50%;
  }

  .userPhone {
    padding: 1px 5px;
    border-radius: 3px;
    background: #f1f1f1;
  }

  .bg_green_light {
    background: rgb(144, 238, 144);
  }

  .bg_yellow_light {
    background: rgba(173, 255, 47, .8);
  }

  /*navbar*/
  .select {
    overflow-y: hidden;
    overflow-x: auto;
    background: #fff;
    width: 100%;
  }

  .mint-navbar .mint-tab-item {
    min-width: 25vw;
  }

  .mint-navbar {
    width: 100%;
    height: 6.5vh !important;
    z-index: 20;
    overflow-x: auto;
  }

  .select.fix .mint-navbar {
    position: fixed;
    top: 9vh;
    left: 0;
    overflow-y: hidden;
    overflow-x: auto;
    width: 100%;
  }

  .mint-navbar .mint-tab-item {
    padding: 4vw 0;
  }

</style>




// WEBPACK FOOTER //
// src/components/imgupdate.vue